<template>
  <div>
    <router-view></router-view>

    <loader></loader>
  </div>
</template>

<script>

  import Loader from "./Partials/Loader"

  export default {
    name: "App",
    components: {Loader},
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue